import { AixAction } from '../aix-action';
import { ErrorWrapper } from '../models/common';
import { type } from '../models/type-cache';
import { SponsorMessage } from './model';

export class LoadMessagesActionTypes {
    static readonly LOAD_MESSAGES = type('[Login] Load Messages');
    static readonly LOAD_MESSAGES_SUCCESS = type('[Login] Load Messages Success');
    static readonly LOAD_MESSAGES_FAILURE = type('[Login] Load Messages Failure');
    static readonly ACKNOWLEDGE_MESSAGE = type('[Messaging] Acknowledge Message');
    static readonly ACKNOWLEDGE_MESSAGE_SUCCESS = type('[Messaging] Acknowledge Message Success');
    static readonly ACKNOWLEDGE_MESSAGE_FAILURE = type('[Messaging] Acknowledge Message Failure');
}

export type LoadMessagesActions =
    | LoadMessages
    | LoadMessagesSuccess
    | LoadMessagesFailure
    | AcknowledgeMessage
    | AcknowledgeMessageSuccess
    | AcknowledgeMessageFailure;

export class LoadMessages implements AixAction {
    readonly type = LoadMessagesActionTypes.LOAD_MESSAGES;
}

export class LoadMessagesSuccess implements AixAction {
    readonly type = LoadMessagesActionTypes.LOAD_MESSAGES_SUCCESS;

    constructor(public payload: SponsorMessage[]) {}
}

export class LoadMessagesFailure implements AixAction {
    readonly type = LoadMessagesActionTypes.LOAD_MESSAGES_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AcknowledgeMessage implements AixAction {
    readonly type = LoadMessagesActionTypes.ACKNOWLEDGE_MESSAGE;

    constructor(public payload: { id: number }) {}
}

export class AcknowledgeMessageSuccess implements AixAction {
    readonly type = LoadMessagesActionTypes.ACKNOWLEDGE_MESSAGE_SUCCESS;

    constructor(public payload: { id: number }) {}
}

export class AcknowledgeMessageFailure implements AixAction {
    readonly type = LoadMessagesActionTypes.ACKNOWLEDGE_MESSAGE_FAILURE;

    constructor(public payload: { id: number; error: ErrorWrapper }) {}
}
